import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../../api/client";
import StatusBadge from "../shared/StatusBadge";

const formatCAD = (n) =>
    new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD",
    }).format(n ?? 0);

const InvoicesList = () => {
    const { t } = useTranslation();
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.invoices()
            .then((r) => setInvoices(r.invoices?.data || []))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                }}
            >
                <div className="section-header" style={{ marginBottom: 0 }}>
                    <h2>{t("invoice.title")}</h2>
                </div>
                <Link
                    to="/admin/invoices/new"
                    className="btn btn--primary btn--sm"
                >
                    {t("invoice.new")}
                </Link>
            </div>

            {loading ? (
                <p style={{ color: "var(--color-text-muted)" }}>
                    {t("common.loading")}
                </p>
            ) : (
                <div
                    className="card"
                    style={{ padding: 0, overflow: "hidden" }}
                >
                    <table className="dash-table">
                        <thead>
                            <tr>
                                <th>{t("invoice.number")}</th>
                                <th>{t("invoice.client")}</th>
                                <th>Project</th>
                                <th>{t("invoice.dueDate")}</th>
                                <th>{t("invoice.status")}</th>
                                <th className="dash-table__right">
                                    {t("invoice.total")}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={7}
                                        className="dash-table__empty"
                                    >
                                        {t("invoice.noInvoices")}
                                    </td>
                                </tr>
                            )}
                            {invoices.map((inv) => (
                                <tr key={inv.id}>
                                    <td className="dash-table__mono">
                                        {inv.invoice_number}
                                    </td>
                                    <td className="dash-table__muted">
                                        {inv.client?.name}
                                    </td>
                                    <td className="dash-table__muted">
                                        {inv.project ? (
                                            <Link
                                                to={`/admin/projects/${inv.project.id}`}
                                            >
                                                {inv.project.title}
                                            </Link>
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                    <td className="dash-table__muted">
                                        {inv.due_date
                                            ? new Date(
                                                  inv.due_date,
                                              ).toLocaleDateString("en-CA")
                                            : "—"}
                                    </td>
                                    <td>
                                        <StatusBadge status={inv.status} />
                                    </td>
                                    <td className="dash-table__right dash-table__mono">
                                        {formatCAD(inv.total)}
                                    </td>
                                    <td>
                                        <Link
                                            to={`/admin/invoices/${inv.id}`}
                                            className="btn btn--ghost btn--sm"
                                        >
                                            {t("common.edit")}
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default InvoicesList;
